<template>
  <div class="container">
    <div class="footer">
      <div class="market_copy_info">
        <span>电话：{{ this.$store.state.marketInfo.tel }}</span>
      </div>
      <div class="market_copy_info">
        <span>地址：{{ this.$store.state.marketInfo.address }}</span>
      </div>
      <div class="market_copy_info">
        <a href="https://beian.miit.gov.cn" target="_blank">备案号：<img src="https://ossimage.xiaochejun.cn/images/icplog.png" width="20" height="20">{{ this.$store.state.marketInfo.icp }}</a>
      </div>
      <div class="market_info">
        <span>Copyright</span>
        <span>2022</span>
        <span>{{ this.$store.state.marketInfo.copyright }}</span>
        <span>版权所有.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.footer {
  height: 140px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content {
  color: #ccc;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.market_info {
  display: flex;
  justify-content: center;
  line-height: 2;
  span {
    margin-right: 20px;
  }
}
.market_copy_info {
  display: flex;
  justify-content: center;
  line-height: 2;
  span {
    margin-right: 20px;
  }
  a,
  a:hover {
    /*去掉a链接的默认样式*/

    color: #757a7e;
    text-decoration: none;
  }
  a:visited {
    text-decoration: none;
    color: #757a7e;
  }
}
</style>
